export const AddConferPage = (destinationLang) => {
  return [
    {
      FormKey: "add-edit-confer-show-items",
      Key: "اقلام انتخاب شده",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "add-new-confer-input-off-doctor",
      Key: "تخفیف بیمه",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "add-new-confer-input-off-markaz",
      Key: "تخفیف مرکز",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "general-public-add-new-confer",
      Key: "ثبت خدمات",
      DistinitationLanguage: destinationLang,
    },

    {
      FormKey: "add-new-confer-navbar-title",
      Key: "ثبت خدمت",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "add-new-alert-confirm-confer",
      Key: "آیا قبض نیز صادر شود؟",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "add-new-alert-confirm-adding-confer",
      Key: "آیا از ثبت خدمت اطمینان دارید؟",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "add-new-alert-no-items-selected",
      Key: "لطفاً آیتم ورودی را انتخاب نمایید",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "general-public-alert-success-operation",
      Key: "انجام عملیات",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "edit-current-confer-submit-button",
      Key: "ویرایش خدمات",
      DistinitationLanguage: destinationLang,
    },
    // ============ end ===============

    // ============ Page Titles ====
    {
      FormKey: "current-patient-page-title",
      Key: "لیست بیماران جاری",
      DistinitationLanguage: destinationLang,
    },
    // ============ Edit Confiramtion Alert==
    {
      FormKey: "edit-confer-alert-sure-edit",
      Key: "آیا از ویرایش خدمات اطمینان دارید؟",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "add-confer-btn-label-select-services-by-detection",
      Key: "انتخاب خدمات با تشخیص",
      DistinitationLanguage: destinationLang,
    },
  ];
};
